<template>
    <div class="private-client">
        <v-row class="d-flex align-center">
            <v-col :cols="12">
                <div class="private-client__controls-wrapper d-flex full-width align-center">
                    <client-autocomplete
                        v-if="!isNewClientMode"
                        ref="clientAutocomplete"
                        v-model="selectedClient"
                        :label="`${$t('choose.client_long')}*`"
                        outlined
                    />
                    <v-spacer v-else />
                    <v-btn
                        v-if="isNewClientBtnVisible"
                        class="ms-3"
                        elevation="0"
                        @click="isNewClientMode = !isNewClientMode"
                        v-text="
                            isNewClientMode ? `${$t('choose.choose')} ${$t('choose.client')}` : $t('new_user_profile')
                        "
                    />
                </div>
            </v-col>
        </v-row>
        <v-expand-transition>
            <create-new-client v-if="isNewClientMode" v-model="newClient" class="mt-8" allow-optional-email />
        </v-expand-transition>
    </div>
</template>

<script lang="ts">
    import {Component, Emit, Prop, VModel, Vue} from 'vue-facing-decorator'
    import ClientAutocomplete from '@/components/account/modals/newOrderRequest/ClientAutocomplete.vue'
    import CreateNewClient from '@/components/account/modals/newOrderRequest/CreateNewClient.vue'

    @Component({
        components: {CreateNewClient, ClientAutocomplete},
    })
    export class PrivateClient extends Vue {
        @VModel() selectedClient
        @Prop({default: false, type: Boolean}) hideNewClient
        @Prop({default: false, type: Boolean}) allowOptionalEmail
        @Prop() _newClient
        @Prop() _isNewClientMode

        @Emit()
        changeNewClient(val) {
            return val
        }

        @Emit()
        changeIsNewClientMode(val) {
            return val
        }

        get isGuest() {
            return !authStore.person
        }

        get isNewClientBtnVisible() {
            return !this.isGuest && !this.hideNewClient
        }

        get newClient() {
            return this._newClient
        }

        set newClient(val) {
            this.changeNewClient(val)
        }

        get isNewClientMode() {
            return this._isNewClientMode
        }

        set isNewClientMode(val) {
            this.changeIsNewClientMode(val)
        }
    }

    export default PrivateClient
</script>
